export * from "./names.component";
